import {Button, Icon} from '@ezcater/tapas';
import {faAngleDown, type IconDefinition} from '@fortawesome/pro-light-svg-icons';
import {twMerge} from 'tailwind-merge';

import Popup from '@/components/ui/Popup';

type EventBarPopupProps = React.ComponentProps<typeof Button> & {
  clickHandler: any;
  defaultOpen?: boolean;
  icon: IconDefinition;
  isOpen: boolean;
  label: string;
  popupClasses?: string;
};

const tailwindClasses = {
  active: 'active:border-green-700 active:bg-green-700',
  base: 'flex w-full items-center gap-2 border-peppercorn-100 px-3 py-2 font-normal h-full',
  focus:
    'focus:z-1 focus:border-green-700 focus:bg-green-700 focus:text-white focus:hover:border-green-700 focus:hover:bg-green-700',
  hover: 'hover:border-green-600 hover:bg-green-600 hover:text-white',
  open: 'z-1 border-green-700 bg-green-700 text-white hover:border-green-700 hover:bg-green-700',
};

const EventBarPopup: React.FC<EventBarPopupProps> = ({
  children,
  clickHandler,
  icon,
  isOpen,
  label,
  popupClasses,
  ...props
}) => {
  return (
    <Popup
      isControlled
      offset={15}
      onPopupToggle={clickHandler}
      open={isOpen}
      placement="bottom-start"
      slotProps={{
        popup: {className: twMerge('w-[460px]', popupClasses)},
        root: {className: 'w-1/3 h-full'},
      }}
      trigger={
        <Button
          aria-label={label}
          title={label}
          variant="outlined"
          {...props}
          className={twMerge(
            tailwindClasses.base,
            tailwindClasses.hover,
            tailwindClasses.focus,
            tailwindClasses.active,
            isOpen && tailwindClasses.open,
            props?.className,
          )}
        >
          <div className="flex w-full items-center justify-between gap-2">
            <div className="flex w-[85%] items-center gap-2">
              <Icon className="shrink-0" icon={icon} />
              <div className="truncate whitespace-nowrap">{label}</div>
            </div>
            <div>
              <Icon className="shrink-0" icon={faAngleDown} />
            </div>
          </div>
        </Button>
      }
    >
      {children}
    </Popup>
  );
};

export default EventBarPopup;
